module.exports = __webpack_public_path__ + "static/media/revlon1.5a2d6f92.jpg";